// Masonry initialise ==========================================
document.addEventListener('DOMContentLoaded', function (event) {
	var elem = document.querySelector('.playground_grid');
	elem.classList.remove('no_js_masonry');
	var msnry = new Masonry(elem, {
		// options
		itemSelector: '.playground_item',
		columnWidth: '.playground_sizer',
		gutter: '.playground_gutter',
		horizontalOrder: true,
		percentPosition: true,
		originLeft: true,
		originTop: true,
		transitionDuration: '0.4s',
		resize: true,
	});
});
